export default __webpack_public_path__ + "app-update-guide.png?55ce5381abfb4531b9cb31efd16089b9";